import React from 'react';
import { SizeGuideHeightSelection, SystemOfMeasurements } from './sizeChartTypes';

interface HeightSelectionProps {
  data: SizeGuideHeightSelection;
  systemOfMeasurements: SystemOfMeasurements;
  usersHeight?: string;
  setHeight: (height: string) => void;
}

const HeightSelection: React.FC<HeightSelectionProps> = ({ data, systemOfMeasurements, usersHeight, setHeight }) => {
  const tabs = data?.tab ?? [];
  if (tabs.length === 0) return null;

  const isValidHeight = tabs.some((tab) => tab.id === usersHeight);
  const usersActiveTab = isValidHeight ? usersHeight : tabs[0]?.id;
  const activeTab = tabs.find((item) => item.id === usersActiveTab);

  const allHaveCm = tabs.every((tab) => tab.value?.cm?.trim());

  return (
    <div className="height-selection">
      {data?.description ? (
        <p className="small-p" tabIndex={0}>
          {data.description}
        </p>
      ) : null}
      <div className="height-buttons-wrapper d-flex">
        {tabs.map(({ value, id: tabId }) => {
          return (
            <button
              key={tabId}
              data-testid={`size-guide-users-height-${tabId}`}
              className={`height-button ${usersActiveTab === tabId ? 'active' : ''}`}
              onClick={() => setHeight(tabId)}
            >
              {allHaveCm && systemOfMeasurements === 'metric' ? value.cm : value.default}
            </button>
          );
        })}
      </div>
      {activeTab?.content?.length ? (
        <div className="length-fit" tabIndex={0}>
          {activeTab.content.map((item) => (
            <p key={item.key} className="length-fit-description">
              {item.key}: <span>{item.value}</span>
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default HeightSelection;
